export default function Skeleton() {
  return {}
}
